<template>
    <div >
        <b-card
                overlay
                :class='welcomeClass'
                :img-src="backgroundImage"
                img-alt="HKIA Picture"
                :title="headerText"
            >
            <!-- img-src="@/assets/aa_background_3.png"
                img-alt="HKIA Picture" -->

            <p v-if="selectOptionText" class="card-text welcome-text-mobile">
                {{selectOptionText}}
            </p>
            <p v-if="selectOptionTextMobile" class="card-text welcome-text-pc">
                {{selectOptionTextMobile}}
            </p>
            <slot></slot>
        </b-card>
    </div>

</template>

<script>
export default {
    props: {
        headerText: {
            default: "Welcome",
            type: String
        },
        staticBackground:{
            default: "/static/aa_background_3.png",
            type: String
        },
        selectOptionText:{
            default: "Select an option from the left",
            type: String
        },
        selectOptionTextMobile:{
            default: "Select an option from the checklist",
            type: String
        },
        fontClass:{
            default: "font-white",
            type: String
        }
    },
    data:function() {
        return {
            baseUrl : process.env.__APP_BASE_PATH__,
            backgroundImage: "",
            welcomeClass : "",
            defaultClass : "welcome-card"
        }
    },
    created:function(){
        this.backgroundImage = this.baseUrl+ this.staticBackground;
        this.welcomeClass = this.defaultClass + " " + this.fontClass
        // console.log(" this.baseUrl", this.baseUrl);
        // console.log(" this.staticBackground", this.staticBackground);
        // console.log(" this.backgroundImage", this.backgroundImage);
    }
}
</script>

<style>
    /* .defaultWelcome{
        background-image: url('/static/Resurfacing_origin.png');
        height: 100%;
        width: 100%;
    } */
    .font-white{

        color:white;
    }
    .font-black{

        color:black;
    }
    .font-grey{
        color: rgb(55,90,127);
    }
    .welcome-card{
    }
    .welcome-card img{
        max-height: calc(100vh - 80px);
    }

    .welcome-text-mobile{
        display:none;
    }

    @media (min-width: 767.98px) {
        .welcome-text-mobile{
            display:block;
        }
        .welcome-text-pc{
            display:none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ui-components/Welcome.vue